import { call, put, takeLatest } from 'redux-saga/effects';
import { getServiceProvider, IServiceProvider } from '../../../services';
import { showSnackbar } from '../utils/showSnackbar';
import actions from '../actions';
import { emptyStringToUndefined } from '../../../utils/helper/strings';
import { requireUserOrThrow } from '../../utils/sagas';
import { ActionType } from '../../../utils/reduxUtils';

const createTourReviewSaga = takeLatest(actions.createTourReview.request.type, function* (
  action: ActionType<typeof actions.createTourReview.request>,
) {
  const { tourCode, rating, review, silent, onSuccess } = action.payload;
  const serviceProvider: IServiceProvider = yield getServiceProvider();

  try {
    yield requireUserOrThrow();
    const reviewSummary = {
      rating,
      review: emptyStringToUndefined(review),
    };
    yield serviceProvider.api.createUpdateTourReview(tourCode, reviewSummary);
    yield put(actions.createTourReview.success(tourCode));

    if (!silent) {
      yield showSnackbar({ key: 'tour_review_dialog.on_success' });
    }

    if (onSuccess) {
      yield call(onSuccess);
    }
  } catch (e) {
    yield put(actions.createTourReview.failure(e));
    serviceProvider.analyticsService.logError(e);
  }
});

const sagas = [createTourReviewSaga];

export default sagas;
